export enum SessionKeys {
  UserSession = 'Dystopia',
}
